module.exports = __webpack_public_path__ + "static/img/bg-id.3a69675c.png";